'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useConvexAuth } from 'convex/react';
import { ActivityItemSlim } from '@/components/ActivityItemSlim';
import { ActivityItem } from '@/components/ActivityItem';
import { NoActivitiesHero } from '@/components/web/NoActivitiesHero';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { Plus, LayoutList, AlignJustify, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { WebSignInCTA } from '@/components/web/WebSignInCTA';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/components/ui/utils';
import { usePaginatedActivitiesQuery } from '@/hooks/usePaginatedActivitiesQuery';
const ITEMS_PER_PAGE = 20;
export default function Web() {
  const $ = _c(33);
  const auth = useConvexAuth();
  const [viewMode, setViewMode] = useState("slim");
  const {
    activities,
    isLoading,
    hasNextPage,
    hasPreviousPage,
    goToNextPage,
    goToPreviousPage
  } = usePaginatedActivitiesQuery(!auth.isAuthenticated, ITEMS_PER_PAGE);
  console.log({
    activities
  });
  if (!auth.isAuthenticated) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex flex-col gap-2 h-full items-center mt-20"><WebSignInCTA /></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (auth.isLoading || isLoading || !activities) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div>Loading...</div>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1>Recent Activities</h1>;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-row gap-2 items-center">{t0}<Link href="/desktop/add-manual"><Button><Plus className="w-4 h-4" />Add Activity</Button></Link></div>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = viewMode === "slim" ? "secondary" : "ghost";
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setViewMode("slim");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AlignJustify className="w-4 h-4" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2) {
    t5 = <Button variant={t2} size="sm" onClick={t3} className="h-8 w-8 p-0">{t4}</Button>;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = viewMode === "fat" ? "secondary" : "ghost";
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setViewMode("fat");
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LayoutList className="w-4 h-4" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6) {
    t9 = <Button variant={t6} size="sm" onClick={t7} className="h-8 w-8 p-0">{t8}</Button>;
    $[10] = t6;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t9) {
    t10 = <div className="flex flex-row gap-2 items-center mb-2 self-stretch justify-between">{t1}<div className="flex flex-row gap-1 bg-muted p-1 rounded-lg">{t5}{t9}</div></div>;
    $[12] = t5;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== activities.length) {
    t11 = activities.length === 0 && <NoActivitiesHero />;
    $[15] = activities.length;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== activities.length) {
    t12 = activities.length === 0 && <div className="flex-1" />;
    $[17] = activities.length;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== activities || $[20] !== viewMode) {
    t13 = activities.length > 0 && <ScrollArea className="flex-1 flex flex-col gap-2 minimal-scrollbar overflow-y-scroll self-stretch space-y-2">{activities.map(activity => <div key={activity._id} className="w-full mb-2">{viewMode === "slim" ? <ActivityItemSlim key={activity._id} activity={activity} context="web" /> : <ActivityItem key={activity._id} activity={activity} context="web" />}<Separator className="mt-2" /></div>)}</ScrollArea>;
    $[19] = activities;
    $[20] = viewMode;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== goToNextPage || $[23] !== goToPreviousPage || $[24] !== hasNextPage || $[25] !== hasPreviousPage) {
    t14 = (hasNextPage || hasPreviousPage) && <div className="flex flex-row justify-center gap-8 items-center mt-4"><div className={cn("flex flex-row gap-2 items-center", !hasPreviousPage ? "pointer-events-none opacity-50" : "cursor-pointer")} onClick={() => hasPreviousPage && goToPreviousPage()}><ChevronLeftIcon className="w-4 h-4" />Previous</div><div className={cn("flex flex-row gap-2 items-center", !hasNextPage ? "pointer-events-none opacity-50" : "cursor-pointer")} onClick={() => hasNextPage && goToNextPage()}>Next <ChevronRightIcon className="w-4 h-4" /></div></div>;
    $[22] = goToNextPage;
    $[23] = goToPreviousPage;
    $[24] = hasNextPage;
    $[25] = hasPreviousPage;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14) {
    t15 = <div className="flex flex-col gap-2 h-full items-center justify-center">{t10}{t11}{t12}{t13}{t14}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}